import { defineMessages } from 'react-intl'

const scope =
  'procurify.modules.purchasing.feature-sets.CatalogSecondaryCategoryAccessSection'

export default defineMessages({
  selectSecondaryCategoryPlaceholder: {
    id: `${scope}.selectSecondaryCategoryPlaceholder`,
    defaultMessage:
      'Select a {singularSecondaryOrgCategoryLabel} to manage user access.',
  },
})
